/* eslint-disable */
import { mapState } from 'vuex'
import { orderBy } from 'lodash'
// services
import firebase from 'firebase/app'
import 'firebase/storage'
import db from '@/services/db'
// helpers
import eventBus from '@/helpers/event-bus'
import filterUtils from '@/helpers/filter'
import store from '@/store'
import { Route, RouterLink } from 'vue-component-router'
import config from '@/config'
import axios from 'axios'
import httpVueLoader from 'http-vue-loader'
import { getPivot } from '@/helpers/pivot'
import { getDate } from '@/helpers/date'
import TableHeadingFilterBuilder from './DataGrid/table/TableHeadingFilterBuilder'

require('firebase/functions')

const Loading = {
  template: `<div>Loading...</div>`,
}

export default {
  functional: true,
  props: {
    template: String,
    detailTemplate: String,
    data: {
      type: Object,
      default: () => ({}),
    },
    computed: {
      type: Object,
      default: () => ({}),
    },
    widget: {
      type: Object,
      default: () => ({}),
    },
    widgetKey: String,
    widgetModel: {},
  },
  render(h, vm) {
    // replace <script> to <script2>
    let regex = /<!--.*?-->|(?:<(\/)?script([ >]))/gm

    if (regex.test(vm.props.template)) {
      vm.props.template = vm.props.template.replace(regex, chunk => {
        return chunk.replace('script', 'script2')
      })
    }

    const customComponents = {}

    for (let key in store.state.customComponents) {
      const component = store.state.customComponents[key]
      try {
        customComponents[component.name] = httpVueLoader(
          'data:text/plain,' + encodeURIComponent(component.code)
        )
      } catch (err) {
        console.error(err)
      }
    }
    //console.log('vm props are', vm.props.widget)
    const template = `
    <div class="widgetContent"  :style="('${vm.props.overflow ||
      null}') != 'height:auto' ? '${vm.props.overflow || null}' : ''"  >
        <div v-if="widget.type === 'card-list'">
          <div>
            <button style='display:none'
              class="btn btn-sm btn-primary"
              @click="editWidget(widgetKey)">edit</button>

              <TableHeadingFilterBuilder
                v-if="filterBuilder"
                class="widgetContent__filters"
                :filter="filterBuilder"
                :gridId="gridId"
                @change="applyBuilderFilters(filterBuilder)"
              />
          </div>
          <paginate
            v-if="pagesCount > 1"
            :page-count="pagesCount"
            :value="currentPage"
            container-class="pagination b-pagination"
            page-class="page-item"
            page-link-class="page-link"
            prev-class="page-item"
            prev-link-class="page-link"
            next-class="page-item"
            next-link-class="page-link"
            prev-text="«"
            next-text="»"
            :click-handler="pageClickHandler"
          />
          <div
            v-if="widget.type === 'card-list'"
            class="widget-card-list${
              vm.props.widget.widthType === 'minAndMaxWidth'
                ? ' _childMinAndMaxWidth'
                : ''
            }"
            widget-id="widgetKey"
            style="margin-bottom: 30px;"
          >
            <div
              v-for="(row, idx) in paginate('${vm.props.widget.dataSource}')"
              :key="idx"
              class="widget-card-list__item${
                vm.props.widget.widthType === 'minAndMaxWidth'
                  ? ' _minAndMaxWidth'
                  : ''
              }"
              ${
                vm.props.widget.widthType === 'columnCount'
                  ? 'data-column-count="' + vm.props.widget.columnCount + '"'
                  : ''
              }
            >
              <div
                class="card"
                ${
                  vm.props.widget.widthType === 'minAndMaxWidth'
                    ? 'style="min-width: ' +
                      vm.props.widget.columnMinWidth +
                      'px; max-width: ' +
                      vm.props.widget.columnMaxWidth +
                      'px;"'
                    : ''
                }
              >${vm.props.template}</div>
            </div>
          </div>
          <paginate
            v-if="pagesCount > 1"
            :page-count="pagesCount"
            :value="currentPage"
            container-class="pagination b-pagination"
            page-class="page-item"
            page-link-class="page-link"
            prev-class="page-item"
            prev-link-class="page-link"
            next-class="page-item"
            next-link-class="page-link"
            prev-text="«"
            next-text="»"
            :click-handler="pageClickHandler"
          />
        </div>
        <div v-else>
          ${vm.props.template}
        </div>
      </div>
    `

    delete vm.props.data.scopedData

    let scopedData = [
      '$sheets',
      ...Object.keys(vm.props.data),
      ...Object.keys(vm.props.computed),
    ]

    scopedData.splice(scopedData.indexOf('spreadsheets'), 1)

    vm.props.data.scopedData = scopedData

    const dynComponent = {
      template,
      components: {
        Route,
        RouterLink,
        TableHeadingFilterBuilder,
        ...customComponents,
      },
      data() {
        return {
          ...vm.props.data,
          eventBus,
          store,
          fbUser,
          workspaces: {},
          widget: vm.props.widget,
          widgetKey: vm.props.widgetKey,
          pagesCount: 1,
          currentPage: 1,
          itemsPerPage: (vm.props.widget && vm.props.widget.itemsPerPage) || 10,
          gridId: null,
          filterBuilder: null,
          page: { test: 'test' },
        }
      },
      watch: {
        pagesCount() {
          if (this.currentPage > this.pagesCount)
            this.currentPage = this.pagesCount || 1
        },
      },
      computed: {
        getWorkspaces: function() {
          return this.workspaces
        },
        ...vm.props.computed,
        ...mapState([
          '$sheets',
          '$nflData',
          '$profile',
          '$profiles',
          'userId',
          'currentTab',
          'currentDash',
          'fbUserModels',
          'models_dashboardModel',
          'fbTrackModels',
          'fbWorkspaceModels',
          'dataGrid_options',
          'pivotGridOptions',
          'computedProps',
        ]),
        pagedData() {
          const gridData = $getGrid(this.dataSource)
          return $getDataGridVals(gridData)
        },

        $FBUserModel() {
          return (model, doNotInitOnAbsence) => {
            try {
              let val = eval(`this.fbUserModels.${model}`) // eslint-disable-line
              if (val === undefined) throw new Error()
              return val
            } catch (err) {
              let val = eval(`vm.props.data.${model}`) || '' // eslint-disable-line
              if (!doNotInitOnAbsence) this.$setFBUserModel(model, val)
            }
            return null
          }
        },
        $FBDashModel() {
          return (model, doNotInitOnAbsence) => {
            try {
              let val
              if (model) {
                val = eval(`this.models_dashboardModel.${model}`) // eslint-disable-line
              } else {
                val = eval(`this.models_dashboardModel`) // eslint-disable-line
              }
              if (val === undefined) throw new Error()
              return val
            } catch (error) {
              return null
            }
          }
        },
        $getWorkspaceData() {
          return model => {
            try {
              let val
              if (model) {
                val = eval(`this.fbWorkspaceModels.${model}`) // eslint-disable-line
              } else {
                val = eval(`this.fbWorkspaceModels`) // eslint-disable-line
              }
              if (val === undefined) return null
              return val
            } catch (error) {
              return null
            }
          }
        },
        $FBWorkspaceList() {
          return (model, doNotInitOnAbsence) => {
            return this.workspaces
          }
        },
        $getDashboardModel() {
          return window.$getDashboardModel
        },
        $dataGrid() {
          return window.$dataGrid
        },
        $getGrid() {
          return window.$getGrid
        },
        $getDataGridVals() {
          return window.$getDataGridVals
        },
        $getDataGridVal() {
          return window.$getDataGridVal
        },
        $getUser() {
          return window.$getUser
        },
        $setUser() {
          return window.$setUser
        },
        $getPivot() {
          return name => {
            const key = Object.keys(this.pivotGridOptions || {}).find(
              key => this.pivotGridOptions[key].name === name
            )
            const pivotData = this.pivotGridOptions[key || name]
            const options = pivotData
              ? JSON.parse(pivotData.options || '{}')
              : {}
            const provider = pivotData ? pivotData.dataProvider || '' : ''
            return getPivot(provider, options).plainRows
          }
        },
      },
      methods: {
        $getProps(cName) {
          if (!this.componentProps) return {}
          if (!this.componentProps[cName]) return {}

          try {
            const dbProps = JSON.parse(this.componentProps[cName])
            const props = {}

            for (let propKey in dbProps) {
              const prop = dbProps[propKey]

              if (!prop.value) continue

              switch (prop.type) {
                case 'String':
                  props[propKey] = eval(
                    `(function () { return "${prop.value}" })()`
                  )
                  break
                case 'Number':
                  props[propKey] = eval(
                    `(function () { return ${prop.value} })()`
                  )
                  break
                case 'Object':
                  props[propKey] = eval(
                    `(function () { return ${prop.value} })()`
                  )
                  break
                case 'Array':
                  props[propKey] = eval(
                    `(function () { return ${prop.value} })()`
                  )
                  break
              }
            }

            return props
          } catch (err) {
            console.error(err)
            return {}
          }
        },
        $dgAddRow: window.$dgAddRow,
        $dgRemoveRow: window.$dgRemoveRow,
        $setDataGridVal: window.$setDataGridVal,
        getStorage() {
          return firebase.storage()
        },
        updateWsName(wsid, wsName) {
          if (wsName) {
            var updateName = firebase
              .functions()
              .httpsCallable('updateWorkspaceName')
            updateName({ workspace: wsid, name: wsName }).then(function(
              result
            ) {
              console.log('about to call function test')
              var res = result.data
              console.log(res)
              fbUser.workspaceName = wsName
              // ...
            })
          }
        },

        callWf(data) {
          data.dashboard = this.currentDash

          const functionsUrl = config.midServer[process.env.APP_CONF.instance]
          const functionLink = `${functionsUrl}/callTheWf`

          axios
            .post(functionLink, JSON.stringify(data))
            .then(res => console.log(functionLink))
            .catch(err => console.log(functionLink))
        },
        getFileName({ file }) {
          return 'file name' + Math.floor(Math.random() * 1000)
        },
        onUpload({ doUpload }) {
          doUpload()
        },
        onDelete({ doDelete }) {
          doDelete()
        },
        $addDashboardModel(model, value) {
          return db.dashboardModels.addDashboardModel(model, value)
        },
        $toArray(val) {
          var arr = []

          _(val).each(function(elem, key) {
            arr.push(elem)
          })
          return arr
        },
        async $queryData(key, query, grid) {
          console.log('query data call start')
          var _this = this
          var queryFunction = firebase.functions().httpsCallable('queryData')
          let data = {
            key: key,
            query: query,
            grid: grid,
            dashboard: this.currentDash,
          }
          let result = await queryFunction(data)
          //page.queryResults = _this.page.queryResults
          console.log('result is', result)
          //this.page.queryResult = result

          console.log('page is is', this.page)
          this.$set(this.page, 'queryResult', result.data)
        },
        $setFBUserModel(model, val) {
          if (!model) throw new Error('[$setFBUserModel] model key is required')
          let id = this.userId

          return new Promise((resolve, reject) => {
            db.widgets.setUserModel(id, model, val, err => {
              if (err) reject(err)
              resolve()
            })
          })
        },
        $setFBWorkspaceData(model, val) {
          if (!model)
            throw new Error('[$setFBWorkspaceData] model key is required')

          db.accessRef.child('workspaces/' + localStorage.workspace).update({
            lastUpdate: new Date().toString(),
            userEmail: fbUser.email,
            emailUpdates: true,
          })

          db.accessRef
            .child('workspaceUpdates/' + localStorage.workspace)
            .update({
              lastUpdate: new Date().toString(),
              userEmail: fbUser.email,
            })

          return new Promise((resolve, reject) => {
            db.accessRef
              .child(
                `workspaces/${localStorage.workspace}/data/${model.replace(
                  '.',
                  '/'
                )}`
              )
              .set(val, err => {
                if (err) reject(err)
                resolve()
              })
          })
        },
        addCanvas() {
          //add canvas to canvas list and get its guid using
          // Generate a reference to a new location and add some data using push()
          var dbref = db.getDBRef('access/workspaces', true).push()

          // Get the unique key generated by push()
          var workspaceKey = dbref.key

          var newWorkspace = {
            dashboard: '-LWDGKf7QhkwDDRqdmIg',
            owner: this.userId,
            workspaceName: '',
          }

          dbref.update(newWorkspace)

          var inviteKey = workspaceKey + '-' + 'test@gmail!com'

          var newInvite = {
            [inviteKey]: {
              email: 'dave@myingenuitylab.com',
              status: 'invited',
              workspace: workspaceKey,
              workspaceName: 'Team 1 Canvas',
            },
          }

          var inviteref = db
            .getDBRef('access/workspaceAccess', true)
            .update(newInvite)
        },
        addManagerWorkspace(name, email, template) {
          // add canvas to canvas list and get its guid using
          // Generate a reference to a new location and add some data using push()
          var dbref = db.getDBRef('access/workspaces', true).push()
          email = email.toLowerCase()
          // Get the unique key generated by push()
          var workspaceKey = dbref.key

          var newWorkspace = {
            dashboard: `${this.$route.params.id}`,
            owner: window.fbUser.uid,
            name: name,
          }

          dbref.update(newWorkspace)

          var inviteKey =
            workspaceKey + '-' + email.replace(/[.]/g, '!').toLowerCase()

          var newInvite = {
            [inviteKey]: {
              email: email,
              status: 'invited',
              id: workspaceKey,
              name: name,
              template: template,
            },
          }

          db.getDBRef('access/workspaceAccess', true).update(newInvite)

          //now make an invite for person who sent the invite
          var inviteKey =
            workspaceKey +
            '-' +
            window.fbUser.email.replace(/[.]/g, '!').toLowerCase()

          var newInvite = {
            [inviteKey]: {
              email: window.fbUser.email.toLowerCase(),
              status: 'invited',
              id: workspaceKey,
              name: name,
              template: template,
            },
          }

          db.getDBRef('access/workspaceAccess', true).update(newInvite)
        },
        updateCanvasName() {},
        $setFBTrackModel(model, val, callback) {
          // if (!model) throw new Error('[$addFBTrackModel] model key is required')
          let id = this.userId
          db.setTrackModel(id, model, val, callback)
        },
        readWidget(path) {
          let ref = db.getRef('widgetsData').child(path)
          let val = eval(`vm.props.data.` + path)
          return val
        },
        setDashdata(d) {
          this.dashData = d
          // console.log(d)
        },
        getModel(uid) {
          db.getRef('dashboardData')
            .child('dashboard')
            .on('value', snapshot => {
              this.setDashdata(snapshot.val())
            })
        },
        addItem(path, item) {
          let ref = db
            .getDBRef('access/workspaces/', true)
            .child(localStorage.workspace)
            .child(path)
          ref.push(item)

          db.accessRef.child('workspaces/' + localStorage.workspace).update({
            lastUpdate: new Date().toString(),
            userEmail: fbUser.email,
          })

          db.accessRef
            .child('workspaceUpdates/' + localStorage.workspace)
            .update({
              lastUpdate: new Date().toString(),
              userEmail: fbUser.email,
            })
        },
        showPrompt() {
          const options = {
            title: 'Enter Canvas Name',
            okLabel: 'Continue',
          }
          this.$dialogs.prompt('Your message!', options).then(res => {
            if (res.ok) {
              // console.log(res.value)
            }
          })
        },
        log: function(e) {
          console.log(e)
        },
        inviteEmails(
          workspace,
          emailList,
          workspaceName,
          template,
          disableInvites
        ) {
          //loop over email invites
          var inviteObj = {}

          // make sure its a real email
          emailList.forEach(function(entry) {
            var email = entry
              .replace(/[.]/g, '!')
              .trim()
              .toLowerCase()
            var sendEmail = entry.trim().toLowerCase()
            var key = workspace + '-' + email
            if (!disableInvites) {
              disableInvites = 'false'
            }

            inviteObj[key] = {
              email: sendEmail,
              status: 'invited',
              id: workspace,
              name: workspaceName,
              template: template,
              disableInvites: disableInvites,
            }
          })

          // push to object with other values

          let ref = db.getDBRef('access/workspaceAccess', true) //.child('workspaceAccess')
          ref.update(inviteObj)
        },
        inviteManagerEmails(emailList, template) {
          //loop over email
          var inviteObj = {}
          var _this = this

          // make sure its a real email
          emailList.forEach(function(entry) {
            _this.addManagerWorkspace(entry.trim(), entry.trim(), template)
          })
        },
        showAlert: message => {
          alert(message)
        },
        $setFBDashModel(path, item) {
          let ref = db.getRef('dashboardData').child(path)
          ref.set(item)
        },
        $dgShowEditRowModal: window.$dgShowEditRowModal,
        applyBuilderFilters(filterBuilder) {
          this.filterBuilder = filterBuilder
          this.paginate(this.gridId)
        },
        paginate(gridId) {
          this.gridId = gridId
          let gridData = $getGrid(this.gridId)

          const { filterBuilder = '{}', meta = {}, defaultSort } =
            this.dataGrid_options[gridId] || {}

          if (defaultSort) {
            gridData = orderBy(gridData, [defaultSort.column], [defaultSort.direction])
          }

          if (!this.filterBuilder) {
            const data = JSON.parse(filterBuilder)
            this.filterBuilder =
              data.rules && data.rules.length > 0 ? data : null
          }
          const filter = filterUtils.filterBuilderToFilter(this.filterBuilder)
          //console.log('about to get datagrid vals')
          let d = $getDataGridVals(gridData)
          //console.log('sort and filter data 2')
          d = filterUtils.filterData(d, filter, meta)

          this.pagesCount = Math.ceil(this.$count(d) / this.itemsPerPage)

          let data = _.cloneDeep(d)

          if (!data) return data

          const allItems = Object.keys(data).map(idx => {
            const item = data[idx]

            item.gridId = gridId

            return item
          })

          const start =
            (this.currentPage - 1) * this.itemsPerPage >= 0
              ? (this.currentPage - 1) * this.itemsPerPage
              : 0
          const end = this.currentPage * this.itemsPerPage
          const filteredItems = allItems.slice(start, end)

          const result = {}

          for (let item of filteredItems) {
            result[item.rowKey] = item
          }

          return result
        },
        pageClickHandler(currentPage) {
          this.currentPage = currentPage || 1
        },
        $sum(model, col) {
          var data = $getGrid(model)
          let total = 0
          for (let i = 0; i < data.length; i++) {
            //console.log(data[i])
            const e = data[i];
            let val = parseFloat(e[col] || 0)
            total = total + val
          }

          // const s = (items, col) =>
          //   items.reduce((a, b) => parseFloat(a) + parseFloat(b[col]), 0)
          // var ret = s(data, col)
          return parseFloat(total)
        },
        $computed(propName) {
          var data = this.computedProps

          return this[propName]
        },
        editWidget(key) {
          this.$store.commit('editWidget', {
            key,
            insert: true,
          })
        },
        // method that run workflow for clicked button in DataGrid
        $btnClick: window.$btnClick,
        setWorkspaces(snapshot) {
          this.workspaces = snapshot.val()
        },
      },
      created() {
        this.widget.perPage = 2
        this.widget.offSet = 0

        // list workspaces user has access to
        db.accessRef
          .child('workspaceAccess')
          .orderByChild('email')
          .equalTo(fbUser.email)
          .on('value', this.setWorkspaces)

        // list workspaces user has access to

        window.updateWsName = this.updateWsName.bind(this)

        window.$setFBUserModel = this.$setFBUserModel.bind(this)
        window.$setFBTrackModel = this.$setFBTrackModel.bind(this)
        window.$FBUserModel = this.$FBUserModel.bind(this)
        window.$getUser = window.$FBUserModel
        window.$setUser = window.$setFBUserModel
        window.$getWorkspaceData = this.$getWorkspaceData.bind(this)
        window.$setFBWorkspaceData = this.$setFBWorkspaceData.bind(this)
        window.$sum = this.$sum.bind(this)
        window.$computed = this.$computed.bind(this)

        window.$setFBDashModel = this.$setFBDashModel.bind(this)
        window.$FBDashModel = this.$FBDashModel.bind(this)
        window.$FBTrackModels = this.$can(
          'update',
          'Dashboard_' + this.currentDash
        )
          ? this.fbTrackModels
          : null
        window.$nflData = this.$nflData
        window.$profile = this.$profile
        window.$profiles = this.$can('update', 'Dashboard_' + this.currentDash)
          ? this.$profiles
          : null
        window.$sheets = this.$sheets
        window.$getPivot = getPivot
        window.getDate = getDate
        window.FBUser = this.FBUser
        window.onSpreadsheetUpdate = function(callback) {
          eventBus.$on('onSpreadsheetUpdate', callback)
        }
      },
      beforeDestroy() {
        for (let propKey in vm.props.data) {
          this[propKey] = null
        }

        this.eventBus = null
        this.store = null
        this.fbUser = null
        this.workspaces = null
        this.widget = null
        this.widgetKey = null
        this.pagesCount = null
        this.currentPage = null
        this.itemsPerPage = null
        this.gridId = null
        this.filterBuilder = null
        this.page = null

        db.accessRef
          .child('workspaceAccess')
          .orderByChild('email')
          .equalTo(fbUser.email)
          .off('value', this.setWorkspaces)
      },
    }
    const component = template ? dynComponent : Loading
    return h(component)
  },
}
